<script>
import RulesDebugPlugin from "../RulesDebug.vue";
import AdminFeaturedModal from "./AdminFeaturedModal.vue";

export default {
  name: "AdminToolbar",
  props: {
    url: { type: String, required: true },
    producto: { type: Object, required: true },
    // Sobreescribe que moneda mostrar para el producto
    moneda: { type: String, default: false },
    isEnabledDestacadoEnBloques: { type: Boolean, default: true },
  },
  components: {
    RulesDebugPlugin,
    AdminFeaturedModal,
  },
  data() {
    return {
      modalDestacados: false,
      actualizandoNombre: false,
      deshabilitando: false,
      destacando: false,
      priorizando: false,
      destacandoEnBloques: false,
      restableciendo: false,
    };
  },
  computed: {
    id() {
      return `${this.producto.proveedor}-${this.producto.codigo}`;
    },
    edicionActiva() {
      return this.producto.nombreEditado || false;
    },
    habilitado() {
      return this.producto.habilitado;
    },
    priorizado() {
      return this.producto.destacado;
    },
    rules() {
      if (this.producto.modulo === "PAQ") {
        if (!this.producto.rules_debug) return null;
        return {
          debug: this.producto.rules_debug.reduce(
            (acc, curr) => ({
              ...acc,
              ...{ [curr.moneda]: curr },
            }),
            {}
          ),
        };
      }
      return this.producto.tarifa;
    },
    destacado() {
      return this.producto.destacado_en_bloques.find(
        (bloque) => bloque.habilitado
      );
    },
  },
  methods: {
    actualizarProducto(parcialState) {
      this.$emit("update:producto", parcialState);
    },
    async accion(accion, datos = null) {
      try {
        const params = new URLSearchParams({
          codigo: this.producto.codigo,
          modulo: this.producto.modulo,
          conector: this.producto.proveedor,
          original: this.producto.nombre,
          nombre: this.producto.nombreEditado || this.producto.nombre,
        });
        if ("destacar_en_bloques" === accion) {
          datos.bloques.forEach((bloque) => {
            const modulo = this.producto.modulo;
            let moneda;
            let rules;
            let salida;
            let ciudades;
            let url;
            if ("PAQ" === modulo) {
              moneda = this.moneda || this.producto.moneda;
              rules = this.producto.tarifa;
              salida = this.producto.salida && this.producto.salida.fecha;
              ciudades = this.producto.ciudades;
              url = this.producto.url.compartir.toString().replace(this.url, '');
              // CIR u otros módulos
            } else {
              moneda = this.moneda || this.producto.tarifa.moneda;
              rules = this.producto.tarifa.rules;
              salida = Array.isArray(this.producto.salidas) ? this.producto.salidas[0] : '';
              ciudades =
                this.producto.ciudades ||
                this.producto.destinos?.map((d) => d.nombre);
              url = this.producto.url_compartir.replace(this.url, '');
            }

            params.append(`url`, url);
            params.append(`foto`, this.producto.foto || "");
            params.append(`dias`, this.producto.dias || 0);
            params.append(`noches`, this.producto.noches || 0);
            params.append(`fecha_salida`, salida || "");
            params.append(`tarifa_moneda`, moneda || "");

            /// Tarifa ///
            // Para CIR
            // Se guarda el monto de la tarifa destacada en ese momento
            params.append(`tarifa_monto`, rules ? rules[moneda].monto : 0);

            
            // Para PAQ (para CIR se guardan también pero no se usan)
            // Se guardan los componentes de la tarifa y se calcula dinámicamente 
            // la tarifa destacada según la configuración actual
            params.append(`tarifa_total`, rules ? rules[moneda].total_raw : 0);
            
            params.append(`tarifa_base`, rules ? rules[moneda].base_raw : 0);
            params.append(`tarifa_base_inicial`, rules ? rules[moneda].base_initial_raw : 0);
            
            params.append(`tarifa_impuestos`, rules ? rules[moneda].taxes_raw : 0);
            params.append(`tarifa_impuestos_inicial`, rules ? rules[moneda].taxes_initial_raw : 0);
            /// Fin Tarifa ///

            params.append(`ciudades`, (ciudades || []).join(" - ") || "");
            params.append(`bloques[${bloque.id}][id]`, bloque.id);
            params.append(
              `bloques[${bloque.id}][habilitado]`,
              bloque.habilitado ? 1 : 0
            );
            bloque.campos.forEach((campo) => {
              params.append(`bloques[${bloque.id}][campos][]`, campo);
            });
          });
        }
        const res = await fetch(
          `${this.url}/services/productos/${accion}?` + params
        );
        const resText = await res.text();
        const msjGenerico = "No se pudo actualizar el producto";
        try {
          const data = JSON.parse(resText);
          if (typeof data !== "object") {
            throw new Error(msjGenerico);
          }
          const { habilitar: habilitado, destacar: destacado, ...rest } = data;
          this.actualizarProducto({
            habilitado,
            destacado,
            ...rest,
          });
          alert("Se ha actualizado el producto correctamente.");
        } catch (e) {
          console.error(e);
          throw new Error(
            "destacar_en_bloques" === accion ? resText : msjGenerico
          );
        }
      } catch (error) {
        alert(error);
      }
    },
    async editar() {
      // Activamos modo de edición
      if (!this.producto.nombreEditado) {
        this.actualizarProducto({
          nombreEditado: this.producto.nombre,
        });
        return;
      }

      // Actualizamos si cambió algo
      if (this.producto.nombreEditado !== this.producto.nombre) {
        this.actualizandoNombre = true;
        await this.accion("editar");
        this.actualizandoNombre = false;
      }
      // ... y desactivamos modo de edición
      this.actualizarProducto({
        nombreEditado: false,
      });
    },
    async deshabilitar() {
      this.deshabilitando = true;
      await this.accion("deshabilitar");
      this.deshabilitando = false;
    },
    async destacarEnBloques(bloques) {
      this.destacandoEnBloques = true;
      await this.accion("destacar_en_bloques", { bloques });
      this.destacandoEnBloques = false;
    },
    async priorizar() {
      this.priorizando = true;
      await this.accion("destacar");
      this.priorizando = false;
    },
    async restablecer() {
      this.restableciendo = true;
      await this.accion("restaurar");
      this.restableciendo = false;
    },
  },
};
</script>

<template>
  <div class="admin-toolbar">
    <button
      type="button"
      class="btn btn-default btn-sm"
      @click="modalDestacados = true"
      data-toggle="modal"
      :data-target="'#' + id"
      :class="{ active: destacado }"
      :title="isEnabledDestacadoEnBloques ? (destacado ? 'Destacado' : 'Destacar') : 'Buscar resultados en base doble para habilitar esta funcionalidad'"
      :disabled="!isEnabledDestacadoEnBloques"
    >
      <i
        class="fa"
        :class="{
          'fa-spinner': destacando,
          'fa-bookmark ': !destacando && destacado,
          'fa-bookmark-o': !destacando && !destacado,
        }"
      ></i>
    </button>

    <button
      type="button"
      class="btn btn-default btn-sm"
      @click="priorizar"
      :class="{ active: priorizado }"
      :title="priorizado ? 'Priorizado' : 'Priorizar'"
    >
      <i
        class="fa"
        :class="{
          'fa-spinner': priorizando,
          'fa-star': !priorizando && priorizado,
          'fa-star-o': !priorizando && !priorizado,
        }"
      ></i>
    </button>

    <button
      type="button"
      class="btn btn-default btn-sm"
      @click="editar"
      :class="{ active: edicionActiva }"
      :title="edicionActiva ? 'Guardar cambios' : 'Editar'"
    >
      <i
        class="fa"
        :class="{
          'fa-spinner': edicionActiva && actualizandoNombre,
          'fa-pencil': !edicionActiva && !actualizandoNombre,
          'fa-pencil-square-o': edicionActiva && !actualizandoNombre,
        }"
      ></i>
    </button>

    <button
      type="button"
      class="btn btn-default btn-sm"
      @click="deshabilitar"
      :class="{ active: !habilitado }"
      :title="habilitado ? 'Deshabilitar' : 'Habilitar'"
    >
      <i
        class="fa"
        :class="{
          'fa-spinner': deshabilitando,
          'fa-eye': !deshabilitando && !habilitado,
          'fa-eye-slash': !deshabilitando && habilitado,
        }"
      ></i>
    </button>

    <button
      type="button"
      class="btn btn-default btn-sm"
      @click="restablecer"
      :class="{ active: restableciendo }"
      :disabled="edicionActiva || deshabilitando || priorizando"
      title="Restablecer estado inicial"
    >
      <i
        class="fa"
        :class="{
          'fa-spinner': restableciendo,
          'fa-history': !restableciendo,
        }"
      ></i>
    </button>

    <rules-debug-plugin
      style="display: inline-block"
      v-if="rules"
      :btnBlock="false"
      :src="rules"
      :moneda-show="producto.moneda"
    >
      <i class="fa fa-calculator"></i>
    </rules-debug-plugin>

    <admin-featured-modal
      v-if="modalDestacados"
      :id="id"
      :producto="producto"
      @update:destacado_en_bloques="destacarEnBloques"
      @close="modalDestacados = false"
    />
  </div>
</template>

<style>
.admin-toolbar > .btn {
  width: 30px;
  padding: 5px !important;
  text-align: center;
}
</style>